<div class="container top-space"
     [class.top-space]="styleMode.includes('withoutHeading') === false"
     [class.no-margin]="hasMargin">
  <div class="row">
    <div class="col-md-8">
      <!--<h1 *ngIf="styleMode.includes('withoutHeading') === false">Favoriten</h1>-->
      <p>
        Erstelle dir deinen <b>persönlichen Feed</b> mit deinen Lieblingsteams
        oder Ligen und erhalte Benachrichtigungen über neue Beiträge, Liveticker und Videos.
      </p>
     <!-- <p *ngIf="!this.userService.isLoggedIn()">
        Um die Favoriten-Funktion nutzen zu können, ist eine Registrierung nötig.
      </p>-->
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-8">
     <app-searchbar class="col-md-6 home-searchbar" styleMode="onHomeContent fullWidth"
                    [placeholder]="'Suche nach Teams oder Ligen'"
                    (searchStringChanged)="searchStringChanged($event)"></app-searchbar>
    </div>
    <!--<div class="col-md-8 register-club__row">
      <a [href]="registerYourClubLink">Dein Verein ist noch nicht auf fan.at? Melde ihn an</a>
    </div>-->
  </div>

  <ng-container *ngIf="searchString !== '' && searchLoading == false">
    <ng-container *ngIf="showSearchResults == true">
      <div class="row mb-2" *ngIf="teams.length != 0">
        <div class="col-md-12 mb-2">
          <span class="heading">Teams mit dem Namen '{{searchString}}'</span>

          <div class="search_results" [class.equally-distributed]="teams.length >= 5">
            <app-my-team-league-cell *ngFor="let team of teams" [team]="team.team"
                                     (onFollow)="loadTeamsAndLeagues()"
                                     (onUnFollow)="loadTeamsAndLeagues()"></app-my-team-league-cell>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="leagues.length != 0">
        <div class="col-md-12 mb-2">
          <span class="heading">Ligen mit dem Namen '{{searchString}}'</span>

          <div class="search_results" [class.equally-distributed]="leagues.length >= 5">
            <app-my-team-league-cell *ngFor="let league of leagues" [league]="league.league"
                                     (onFollow)="loadTeamsAndLeagues()"
                                     (onUnFollow)="loadTeamsAndLeagues()"></app-my-team-league-cell>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="showSearchResults == false && searchString.length >= 3">
      <div class="row mb-2">
        <div class="col-md-12 mb-2">
          <p>Keine Ergebnisse</p>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="mb-2" [class.invisible]="searchString.length >= 3">
    <app-favourites-home #favouritesHomeComponent [onMobileView]="true"
                         (onSelectionChanged)="onStateAndLeagueSelectionChanged($event)"></app-favourites-home>
  </div>

  <ng-container *ngIf="onlyShowStatesAndLeagues === false">
    <ng-container *ngIf="this.userService.isLoggedIn() && searchString.length < 3">
      <div class="row" *ngIf="teamsOfUser.length !== 0">
        <div class="col-md-12 mb-2">
          <span class="heading">Meine Teams</span>

          <div class="my-teams-and-leagues">
            <app-my-team-league-cell *ngFor="let team of teamsOfUser"
                                     [team]="team.team"
                                     (onUnFollow)="loadTeamsAndLeagues()"></app-my-team-league-cell>
          </div>
        </div>
      </div>

      <div class="row mb-2" *ngIf="leaguesOfUser.length !== 0">
        <div class="col-md-12">
          <span class="heading">Meine Ligen</span>

          <div class="my-teams-and-leagues">
            <app-my-team-league-cell *ngFor="let league of leaguesOfUser"
                                     [league]="league.league"
                                     (onUnFollow)="loadTeamsAndLeagues()"></app-my-team-league-cell>
          </div>
        </div>
      </div>
    </ng-container>



    <ng-container *ngIf="searchString.length < 3">
      <div class="row mb-2" *ngIf="popularTeams.length > 0">
        <div class="col-md-12 mb-md-2">
          <span class="heading">Beliebte Teams</span>

          <div class="popular_teams" [class.equally-distributed]="popularTeams.length >= 5">
            <app-search-cell *ngFor="let team of popularTeams"
                             [team]="team.team" [smallMargin]="true"></app-search-cell>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="popularLeagues.length > 0">
        <div class="col-md-12 mb-md-2">
          <span class="heading">Beliebte Ligen</span>

          <div class="popular_leagues" [class.equally-distributed]="popularLeagues.length >= 5">
            <app-search-cell *ngFor="let league of popularLeagues"
                             [league]="league.league" [smallMargin]="true"></app-search-cell>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
